/**
 * What one host width and one host height are worth in em for a glyph whose drawing is not
 * square (`aspect` = its width / height), drawn in an em square of its longer side. The glyph
 * takes the smaller of the two as its font size (icon.component.scss), so the drawing fits a
 * non-square host the way a 100% `<svg>` fitted its viewBox. A square glyph keeps the default 1.
 */
export function glyphEmBox(aspect: number | undefined) {
  if (aspect === undefined) {
    return { width: null, height: null };
  }

  return aspect >= 1 ? { width: 1, height: aspect } : { width: 1 / aspect, height: 1 };
}
